const events = [
    {
      id: 1,
      name: 'The Advent of the Artist’',
      place: 'Petite Galerie - Louvre',
      thumbnail: 'louvre-exposition-petite-galerie-140-87-px.jpg',
      description: 'For its fifth season, the Louvre’s Petite Galerie—a space dedicated to art and cultural education— is holding an exhibition titled ‘The  Advent  of  the  Artist’. Discover artworks from Delacroix, Rembrandt or Tintoretto.',
      categories: ['ALL', 'ARTS'],
      address: 'MAPS POINT ADDRESS',
      country: 'France',
      state: 'Paris',
      artist: 'Delacroix, Rembrandt & Tintoretto',
      virsturl: 'https://petitegalerie.louvre.fr/visite-virtuelle/saison5/'
    },
    {
      id: 2,
      name: 'Solomon R. Guggenheim Museum',
      place: 'Solomon R. Guggenheim Museum',
      thumbnail: 'solomon-guggenheim-museum.jpg',
      description: 'Although our catalytic Frank Lloyd Wright-designed building is temporarily closed, the Guggenheim continues on as a virtual community committed to igniting ideas, discussion and creativity.',
      categories: ['ALL', 'ARTS'],
      address: 'MAPS POINT ADDRESS',
      country: 'United States of America',
      state: 'New York',
      artist: 'Various artist',
      virsturl: 'https://artsandculture.google.com/streetview/solomon-r-guggenheim-museum-interior-streetview/jAHfbv3JGM2KaQ?sv_lng=-73.95902634325634&sv_lat=40.78285751667664&sv_h=19.334227915238074&sv_p=0.052159543970120126&sv_pid=MfnUmHRyOSzMtY3vtYU05g&sv_z=1'
    },
    {
      id: 3,
      name: 'Smithsonian National Museum of Natural History',
      place: 'Smithsonian National Museum of Natural History',
      thumbnail: 'gallery-grey2.jpg',
      description: 'The Smithsonian, National Museum of Natural History virtual tours allow visitors to take self-guided, room-by-room tours of select exhibits and areas within the museum from their desktop or mobile device. Visitors can also access select collections and research areas at our satellite support and research stations as well as past exhibits no longer on display.',
      categories: ['ALL', 'ARTS', 'HISTORIC'],
      address: 'MAPS POINT ADDRESS',
      country: 'United States of America',
      state: 'Washington, D.C',
      artist: '',
      virsturl: 'https://naturalhistory2.si.edu/vt3/NMNH/'
    },
    {
      id: 4,
      name: 'Van Gogh Museum',
      place: 'Van Gogh Museum',
      thumbnail: 'logo-vangogh-museum.png',
      description: 'The Van Gogh Museum in Amsterdam houses the largest collection of artworks by Vincent van Gogh (1853-1890) in the world. The permanent collection includes over 200 paintings by Vincent van Gogh, 500 drawings and more than 750 letters. The museum also presents exhibitions on various subjects from 19th-century art history.',
      categories: ['ALL', 'ARTS'],
      address: 'MAPS POINT ADDRESS',
      country: 'Netherlands',
      state: 'Amsterdam',
      artist: 'Van Gogh',
      virsturl: 'https://artsandculture.google.com/streetview/van-gogh-museum-groundfloor/2QHwyv_Y6gueAw?hl=en&sv_lng=4.8808198&sv_lat=52.3585336&sv_h=-19.92648221949179&sv_p=-14.958125813166376&sv_pid=T4EwMNbRYOhcEPF8T1I8xw&sv_z=1.0000000000000002'
    },
    {
      id: 5,
      name: 'Sistine Chapel',
      place: 'The Vatican Museum',
      thumbnail: 'sistineChapel.1280.1280.png',
      description: 'The Sistine Chapel takes its name from Pope Sixtus IV della Rovere (pontiff from 1471 to 1484) who had the old Cappella Magna restored between 1477 and 1480. The 15th century decoration of the walls includes: the false drapes, the Stories of Moses and of Christ and the portraits of the Popes.',
      categories: ['ALL', 'ARTS', 'HISTORIC'],
      address: 'MAPS POINT ADDRESS',
      country: 'Vatican',
      state: 'Vatican City',
      artist: 'Pietro Perugino, Sandro Botticelli, Domenico Ghirlandaio, Cosimo Rosselli & Biagio di Antonio',
      virsturl: 'http://www.museivaticani.va/content/museivaticani/en/collezioni/musei/cappella-sistina/tour-virtuale.html'
    },
    {
      id: 6,
      name: "Raphael's Rooms",
      place: 'The Vatican Museum',
      thumbnail: 'raphaels-room.1280.1280.png',
      description: 'The four rooms known as the Stanze of Raphael formed part of the apartment situated on the second floor of the Pontifical Palace that was chosen by Julius II della Rovere (pontiff from 1503 to 1513) as his own residence and used also by his successors. The pictorial decoration was executed by Raphael and his school between 1508 and 1524.',
      categories: ['ALL', 'ARTS', 'HISTORIC'],
      address: 'MAPS POINT ADDRESS',
      country: 'Vatican',
      state: 'Vatican City',
      artist: 'Raphael',
      virsturl: 'http://www.museivaticani.va/content/museivaticani/en/collezioni/musei/stanze-di-raffaello/tour-virtuale.html'
    },
    {
      id: 7,
      name: 'Langley Research Center',
      place: 'NASA',
      thumbnail: 'nasa-logo.png',
      description: 'Take a virtual tour around the NASA Langley Research Center and explore their role in NASA conducting studies on Earth, Moon, Mars, etc.',
      categories: ['ALL', 'CIENCE'],
      address: 'MAPS POINT ADDRESS',
      country: 'United States of America',
      state: 'Virginia',
      artist: '',
      virsturl: 'https://oh.larc.nasa.gov/oh/'
    },
    {
      id: 8,
      name: 'Glenn Research Center',
      place: 'NASA',
      thumbnail: 'nasa-logo.png',
      description: 'Get an inside look at NASA Glenn Research Center’s facilities. Tap the icons to view videos, images and see testing in action.',
      categories: ['ALL', 'CIENCE'],
      address: 'MAPS POINT ADDRESS',
      country: 'United States of America',
      state: 'Virginia',
      artist: '',
      virsturl: 'https://www.nasa.gov/glennvirtualtours'
    },
    {
      id: 9,
      name: 'Panda Cam',
      place: 'Zoo Atlanta',
      thumbnail: 'panda-cam.jpg',
      description: 'We know the pandas bring you joy, and in these extraordinary times, we’re glad. During a time when the COVID-19 epidemic is touching all of our lives, we’re proud and glad that people around the world find joy in PandaCam. You can help support our giant panda program and Zoo Atlanta during this unusual time – thank you for your commitment!',
      categories: ['ALL', 'PARKS', 'LIVE_CAMS'],
      address: 'MAPS POINT ADDRESS',
      country: 'United States of America',
      state: 'Atlanta',
      artist: '',
      virsturl: 'https://www.youtube.com/watch?v=qbteZBKKgiE&feature=emb_title'
    },
    {
      id: 10,
      name: 'Georgia Aquarium',
      place: 'Georgia Aquarium',
      thumbnail: 'georgia-aquarium.jpg',
      description: 'Georgia Aquarium is a nonprofit committed to inspiring awareness and preservation of our ocean and aquatic animals worldwide.',
      categories: ['ALL', 'PARKS'],
      address: 'MAPS POINT ADDRESS',
      country: 'United States of America',
      state: 'Georgia',
      artist: '',
      virsturl: 'https://www.georgiaaquarium.org/webcam/beluga-whale-webcam/'
    },
    {
      id: 11,
      name: 'SeaWorld Orlando',
      place: 'SeaWorld Orlando',
      thumbnail: 'sea-world.jpg',
      description: 'The virtual tour of Seaworld includes a tour of Discovery Cove and the option to"ride" the steel roller coaster Mako.',
      categories: ['ALL', 'PARKS'],
      address: 'MAPS POINT ADDRESS',
      country: 'United States of America',
      state: 'Florida',
      artist: '',
      virsturl: 'https://www.visitorlando.com/en/things-to-do/virtual-tours/seaworld-orlando'
    },
    {
      id: 12,
      name: 'Hotel Legoland',
      place: 'Billund Resort',
      thumbnail: 'hotel-legoland.jpg',
      description: 'The Great Lego Race and Miniland USA are just two of the attractions you can check out in a virtual tour of the park.',
      categories: ['ALL', 'PARKS'],
      address: 'MAPS POINT ADDRESS',
      country: 'United States of America',
      state: 'Florida',
      artist: '',
      virsturl: 'https://www.legoland.dk/en/accommodation/hotel-legoland/virtual-tour/'
    },
    {
      id: 13,
      name: 'Crossing Lines',
      place: 'National Gallery Victoria',
      thumbnail: 'crossing-lines.jpg',
      description: 'In an unprecedented, world premiere exhibition, the National Gallery of Victoria presents the work of two of the most significant and influential artists of the late twentieth century in Keith Haring | Jean-Michel Basquiat: Crossing Lines.',
      categories: ['ALL', 'ARTS'],
      address: 'MAPS POINT ADDRESS',
      country: 'Australia',
      state: 'Victoria',
      artist: 'Haring & Basquiat',
      virsturl: 'https://www.ngv.vic.gov.au/virtual-tours/haring-basquiat/'
    },
    {
      id: 14,
      name: 'Companionship in the Age of Loneliness',
      place: 'National Gallery Victoria',
      thumbnail: 'KAWS-ngv.jpg',
      description: 'Contemporary American artist KAWS, a.k.a Brian Donnelly, is one of the most resonant artists of his generation. In an Australian first, KAWS: Companionship In The Age Of Loneliness is a comprehensive survey of 25 years of KAWS’s oeuvre, full of humour, hope and humanity, celebrating his ability to connect with broad audiences.',
      categories: ['ALL', 'ARTS'],
      address: 'MAPS POINT ADDRESS',
      country: 'Australia',
      state: 'Victoria',
      artist: 'KAWS',
      virsturl: 'https://www.ngv.vic.gov.au/virtual-tours/kaws/'
    },
    {
      id: 15,
      name: 'Bleached Gothic',
      place: 'National Gallery Victoria',
      thumbnail: 'hicks-ngv.jpg',
      description: 'Photographer Petrina Hicks and Curator Maria Quirk each discuss the tension between familiarity and strangeness in this major exhibition. Hicks’s interest in the ‘hyper-real space’ draws inspiration from mythology and traditional gender representations.',
      categories: ['ALL', 'ARTS'],
      address: 'MAPS POINT ADDRESS',
      country: 'Australia',
      state: 'Victoria',
      artist: 'Petrina Hicks',
      virsturl: 'https://www.ngv.vic.gov.au/virtual-tours/petrina-hicks/'
    },
    {
      id: 16,
      name: "Musee d'Orsay",
      place: "Musee d'Orsay",
      thumbnail: 'musee-d-orsay.jpg',
      description: "In the centre of Paris on the banks of the Seine, opposite the Tuileries Gardens, the museum was installed in the former Orsay railway station, built for the Universal Exhibition of 1900. So the building itself could be seen as the first 'work of art' in the Musee d'Orsay, which displays collections of art from the period 1848 to 1914.",
      categories: ['ALL', 'ARTS'],
      address: 'MAPS POINT ADDRESS',
      country: 'France',
      state: 'Paris',
      artist: 'Petrina Hicks',
      virsturl: 'https://artsandculture.google.com/streetview/musée-d’orsay-paris/KQEnDge3UJkVmw?hl=en&sv_lng=2.327089926444344&sv_lat=48.85968476784497&sv_h=252&sv_p=0&sv_pid=FjndSjvl55w81vbNYu5DfA&sv_z=1'
    },
    {
      id: 17,
      name: "National Museum of Modern and Contemporary Art",
      place: "National Museum of Modern and Contemporary Art",
      thumbnail: 'MMCA-Gwacheon.jpg',
      description: "MMCA intends to function as a cultural platform that encourages communication and cross-pollination of contemporary art with other various disciplines of art, science, and humanities. MMCA’s foremost mission is to offer a culturally rewarding experience to its visitors.",
      categories: ['ALL', 'ARTS'],
      address: 'MAPS POINT ADDRESS',
      country: 'Korea',
      state: 'Gwacheon-si',
      artist: '',
      virsturl: 'https://artsandculture.google.com/streetview/national-museum-of-modern-and-contemporary-art-korea/fQHn7MvGkiYbbQ?hl=en&sv_lng=127.0198366288473&sv_lat=37.43103069967624&sv_h=330.05678490029964&sv_p=20.49342006792864&sv_pid=0XFyRZfjKrjJCwSYmMriUA&sv_z=0.7353896392022259'
    },
    {
      id: 18,
      name: "Rijksmuseum",
      place: "Rijksmuseum",
      thumbnail: 'Rijksmuseum.jpg',
      description: "The Rijksmuseum is the museum of the Netherlands. Its world-famous masterworks from the Dutch Golden Age include the Milkmaid by Vermeer and Rembrandt's Night Watch. The Rijksmuseum itself is also a masterpiece. The collection is presented in a stunning building with amazing interior design. In 80 galleries 8,000 objects tell the story of 800 years of Dutch art and history, from the Middle Ages to Mondrian.",
      categories: ['ALL', 'ARTS'],
      address: 'MAPS POINT ADDRESS',
      country: 'Netherlands',
      state: 'Amsterdam',
      artist: '',
      virsturl: 'https://artsandculture.google.com/streetview/rijksmuseum/iwH5aYGoPwSf7g?hl=en&sv_lng=4.885283712508563&sv_lat=52.35984312584405&sv_h=344.3938098751762&sv_p=12.160973556363345&sv_pid=fOVcUXQW2wpRf33iUmxEfg&sv_z=1'
    },
    {
      id: 19,
      name: "Uffizi Gallery",
      place: "Uffizi Gallery",
      thumbnail: 'uffizi-gallery.jpg',
      description: "The Uffizi was designed by Giorgio Vasari in 1560 for Cosimo I de'Medici to house the Granducal Magistratures of Tuscany. Over time, the top floor loggia became an exhibition of the dynastic collection of ancient sculpture, artwork and artifacts.",
      categories: ['ALL', 'ARTS'],
      address: 'MAPS POINT ADDRESS',
      country: 'Italy',
      state: 'Florence',
      artist: '',
      virsturl: 'https://artsandculture.google.com/streetview/uffizi-gallery/1AEhLnfyQCV-DQ?hl=en&sv_lng=11.2558913&sv_lat=43.768841&sv_h=347.290050942181&sv_p=-7.923872772667181&sv_pid=BVLiSlIAlLP0xHA5-yERqw&sv_z=1'
    },
    {
      id: 20,
      name: "Museu de Arte de Sao Paulo",
      place: "Museu de Arte de Sao Paulo",
      thumbnail: 'masp-sp.jpg',
      description: "The Museu de Arte de São Paulo is a private, nonprofit museum founded by Brazilian businessman Assis Chateaubriand, in 1947, as Brazil’s first modern museum. Today, MASP’s collection contains more than 8.000 works, including paintings, sculptures, objects, photographs, and costumes from a wide range of periods, encompassing art from Africa, Asia, Europe, and the Americas.",
      categories: ['ALL', 'ARTS'],
      address: 'MAPS POINT ADDRESS',
      country: 'Brazil',
      state: 'Sao Paulo',
      artist: '',
      virsturl: 'https://artsandculture.google.com/streetview/masp-museu-de-arte-de-são-paulo-assis-chateaubriand/YgHyUAyv_g4cvg?hl=en&sv_lng=-46.65619415237199&sv_lat=-23.56123107299121&sv_h=108.36000000000001&sv_p=0&sv_pid=_61eOr97mwcsE6DNjowi3g&sv_z=1'
    },
    {
      id: 21,
      name: "Polar Bear Cubs Cam",
      place: "Ouwehand Park",
      thumbnail: 'polar-bear-cubs.png',
      description: "For unbelievably cute webcam footage, you can’t miss this live stream of the twin polar bear cubs at Ouwehans Dierenpark in the Netherlands! They also have a live Pandacam here, where you can keep a close eye on the beautiful giant pandas.",
      categories: ['ALL', 'PARKS', 'LIVE_CAMS'],
      address: 'MAPS POINT ADDRESS',
      country: 'Netherlands',
      state: 'Rhenen',
      artist: '',
      virsturl: 'https://www.youtube.com/watch?v=2DoCgGP_0g0&feature=emb_logo'
    },
  ];

export default events;